export function SkeletonChart() {
  return (
    <div className="mt-8 p-4 bg-white dark:bg-gray-800 rounded-lg shadow animate-pulse">
      <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/4 mb-4"></div>
      <div className="h-40 bg-gray-200 dark:bg-gray-700 rounded"></div>
    </div>
  );
}

export function SkeletonTable({ rows = 5, columns = 4 }) {
  return (
    <div className="overflow-x-auto mt-8 rounded-lg animate-pulse">
      <div className="min-w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg">
        {/* Header */}
        <div className="bg-gray-100 dark:bg-gray-700 flex">
          <div className="py-3 px-4 w-1/6">
            <div className="h-6 bg-gray-200 dark:bg-gray-600 rounded"></div>
          </div>
          {Array(columns).fill(0).map((_, i) => (
            <div key={i} className="py-3 px-4 flex-1 text-center">
              <div className="h-6 bg-gray-200 dark:bg-gray-600 rounded mb-2"></div>
              <div className="h-4 bg-gray-200 dark:bg-gray-600 rounded w-3/4 mx-auto"></div>
            </div>
          ))}
        </div>
        
        {/* Rows */}
        {Array(rows).fill(0).map((_, rowIndex) => (
          <div key={rowIndex} className="flex border-b border-gray-200 dark:border-gray-700">
            <div className="py-3 px-4 w-1/6">
              <div className="flex items-center">
                <div className="w-6 h-6 rounded-full bg-gray-200 dark:bg-gray-600 mr-2"></div>
                <div className="h-4 bg-gray-200 dark:bg-gray-600 rounded w-3/4"></div>
              </div>
            </div>
            
            {Array(columns).fill(0).map((_, colIndex) => (
              <div key={colIndex} className="py-3 px-4 flex-1 text-center">
                <div className="h-4 bg-gray-200 dark:bg-gray-600 rounded w-1/2 mx-auto mb-2"></div>
                <div className="h-3 bg-gray-200 dark:bg-gray-600 rounded w-1/3 mx-auto"></div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}